"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useI18n = _interopRequireDefault(require("@paprika/l10n/lib/useI18n"));

var sc = _interopRequireWildcard(require("./ArrowItem.styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var propTypes = {
  /** To set the ArrowItem as disabled */
  isDisabled: _propTypes["default"].bool,

  /** Callback to be executed when the ArrowItem is clicked or activated by keyboard. */
  onClick: _propTypes["default"].func,

  /** What type of arrow to display */
  type: _propTypes["default"].string
};
var defaultProps = {
  isDisabled: false,
  onClick: function onClick() {},
  type: "right"
};

function ArrowItem(props) {
  var isDisabled = props.isDisabled,
      onClick = props.onClick,
      type = props.type;
  var Icon = (0, sc.getIcon)(type);
  var I18n = (0, _useI18n["default"])();
  return /*#__PURE__*/_react["default"].createElement(sc.ArrowItemWrapper, null, /*#__PURE__*/_react["default"].createElement(sc.ArrowItem, {
    "aria-label": I18n.t("pagination.".concat(type)),
    isDisabled: isDisabled,
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(Icon, {
    isDisabled: isDisabled
  })));
}

ArrowItem.defaultProps = defaultProps;
ArrowItem.displayName = "Pagination.ArrowItem";
ArrowItem.propTypes = propTypes;
var _default = ArrowItem;
exports["default"] = _default;
//# sourceMappingURL=ArrowItem.js.map